/*
 * Copyright (c) 2020.
 * Simon
 */

import {FANPAGE_GET_HEARS_SUCCESS, HEAR_CREATE_SUCCESS, HEAR_DETAIL_SUCCESS, HEAR_UPDATE_SUCCESS,} from '../types';

/**
 * @param {*} state
 * @param {*} action
 */
const HearsReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    let fanpageId = action.payload.fanpage_id;
    if (fanpageId === undefined || fanpageId === null) return state;
    if (state[fanpageId] === undefined) state[fanpageId] = {};

    switch (action.type) {
        case FANPAGE_GET_HEARS_SUCCESS:
            let hears = action.payload.data.data;

            hears.map((hear) => {
                let hearId = hear['hear_id'];
                state[fanpageId][hearId] = hear;
                return true;
            });

            return {...state, action};

        case HEAR_DETAIL_SUCCESS:
        case HEAR_CREATE_SUCCESS:
        case HEAR_UPDATE_SUCCESS:
            let hearId = action.payload.data['hear_id'];
            state[fanpageId][hearId] = action.payload.data;
            return {...state, action};
        default:
            return {...state};
    }
};

export {HearsReducer}